

import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

const Container = styled.div`
  width: ${({inputWidth}) => inputWidth};
  height: 40px;
  filter: none !important;
  background-color: ${({ theme }) => theme.mainBgColor};
  position: relative;

  p {
    margin-top: 5px;
    color: red;
    font-size: 10px;
    line-height: 16px;
  }

  input {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
    border: 1px solid
      ${({ theme, isActive, isError }) =>
        isError
          ? "var(--color-red)"
          : isActive
          ? "#EBB00E"
          : theme.mainBorderColor};
    border-color: ${({ showErrors }) => showErrors && "var(--color-red)"};
    border-radius: ${({ radius }) => radius};
    color: var(--color-dark);
    background-color: ${({ theme }) => theme.mainBgColor};

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    &::-webkit-calendar-picker-indicator {
      filter: ${({ theme }) => theme.inputDateIconColor};
    }
  }

  input:focus ~ label {
    color: ${({ theme }) => theme.mainTextColor};
    color: ${({ showErrors }) => showErrors && "var(--color-red)"};
    transform: translateY(-22px);
  }

  label {
    position: absolute;
    transform: ${({ value }) => value && "translateY(-22px)"};
    bottom: 12px;
    left: 20px;
    font-size: 12px;
    font-weight: var(--font-weight-lg);
    pointer-events: none;
    transition: all 0.3s ease;
    padding: 3px;
    border-radius: 3px;
    z-index: 5;
    color: ${({ theme, value }) =>
      value ? theme.mainTextColor : theme.secondaryTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
  }
`;

const InputYuklemeDate = ({ data, setData, inputWidth, name, labelText }) => {


  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth} onClick={e => e.stopPropagation()}>
      <input
        type="date"
        id={"text"}
        onChange={(e) => setData(e.target.value)}
        value={data}
        name={name}
      />
      <label htmlFor={"text"}>{labelText}</label>
    </Container>
  );
};

export default InputYuklemeDate;

